var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"h-splitter",style:(_vm.hs_style),on:{"mousedown":_vm.hs_mousedown}})
}
var staticRenderFns = []

export { render, staticRenderFns }